import CommonSubtitle from "@/components/common/CommonSubtitle";
import Image, { StaticImageData } from "next/image";

export type TopImageInfoType = {
  topInfoSection: {
    topMainTitle?: string;
    topTitle: string;
    topSubtitle: string;
    topImage: StaticImageData;
  };
};

const TopInfoImageSection = ({
  topInfoSection,
}: {
  topInfoSection: TopImageInfoType;
}) => {
  return (
    <section className="container px-4">
      <div className="flex flex-col gap-6 lg:mb-12 lg:flex-row xlg:gap-8 xl:mb-0 xl:gap-10">
        <div className="-mt-8 flex flex-1 items-center justify-center sm:w-full">
          <div className="flex flex-col gap-4 pr-4 xl:gap-6 xl:pr-36">
            <div className="flex flex-col gap-2 xl:gap-4">
              {topInfoSection.topInfoSection.topMainTitle && (
                <p className="text-[14px] font-normal text-[#717171] xl:text-[16px]">
                  {topInfoSection.topInfoSection.topMainTitle}
                </p>
              )}
              <h3 className="text-[20px] font-medium text-[#202020] lg:text-[22px]">
                {topInfoSection.topInfoSection.topTitle}
              </h3>
              <CommonSubtitle
              >
                {topInfoSection.topInfoSection.topSubtitle}
              </CommonSubtitle>
            </div>
          </div>
        </div>
        <div className="relative h-fit flex-1 overflow-hidden sm:w-full xl:h-[520px]">
          <Image
            src={topInfoSection.topInfoSection.topImage}
            alt="Kroolo AI tools feature overview"
          />
        </div>
      </div>
    </section>
  );
};

export default TopInfoImageSection;
